import { useState } from "react";

/**
 * TeamLogo: shows the team crest if logo_url is set, otherwise falls back
 * to the first letter of the team name styled with the division accent color.
 */
export default function TeamLogo({ team, accentColor = "rgb(var(--tc-2bb6ff))", size = 48, className = "" }) {
    const [failed, setFailed] = useState(false);
    const hasLogo = team?.logo_url && !failed;
    const dim = `${size}px`;

    if (hasLogo) {
        return (
            <div
                className={`shrink-0 flex items-center justify-center bg-tffffff border border-t22252a p-1 rounded-full overflow-hidden ${className}`}
                style={{ width: dim, height: dim }}
                data-testid={`team-logo-${team.id}`}
            >
                <img
                    src={team.logo_url}
                    alt={team.name}
                    className="max-w-full max-h-full object-contain"
                    onError={() => setFailed(true)}
                    loading="lazy"
                />
            </div>
        );
    }

    return (
        <div
            className={`shrink-0 border flex items-center justify-center op-heading rounded-full ${className}`}
            style={{
                width: dim,
                height: dim,
                borderColor: accentColor,
                color: accentColor,
                fontSize: `${size * 0.45}px`,
            }}
            data-testid={`team-logo-fallback-${team?.id || "x"}`}
        >
            {team?.name?.charAt(0).toUpperCase() || "?"}
        </div>
    );
}
